
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {ICarUnion} from "@/modules/CarList/interfaces/car-union.interface";
  import CarNumber from "@/components/CarNumber.vue";
  import PhoneInput from "@/components/PhoneInput.vue";

  @Component({
    components: {
      CarNumber,
      PhoneInput,
    },
  })
  export default class CarsUnionCell extends Vue {
    @Prop() carUnion: ICarUnion.IEntity;
    @Prop() value: string;
    @Prop() index: number;
    @Prop() cell: ICarUnion.ITableCell;
    @Prop() active: boolean;
    @Prop() errorProps: string[];

    $refs: any;
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    propType = ICarUnion.PropType;
    dateFormat = 'DD.MM.YYYY HH:mm';
    displayPassword = false;
    displayNumber = true;

    get selectValueMultiple() { return this.value ? this.value.split(',').map(item => +item) : []; }
    get selectValue() { return +this.value; }

    inputAction(value) {
      let resultValue = value;
      if (this.cell.prop === 'phone' && ['+7 (', '+7 '].includes(value)) resultValue = null;
      this.$emit('input', resultValue);
    }

    updateNumber() {
      this.displayNumber = false;
      setTimeout(() => {
        this.displayNumber = true;
      }, 0);
    }

    generatePassword() {
      let password = "";
      // const symbols = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_";
      const symbols = "0123456789";
      for (let i = 0; i < 6; i++){
        password += symbols.charAt(Math.floor(Math.random() * symbols.length));
      }
      this.inputAction(password);
    }
  }
